// extracted by mini-css-extract-plugin
module.exports = {"block":"LangSelector_block__2XFh7","link":"LangSelector_link__3454E"};